import PhilanthropistBadge from 'assets/images/badges/philanthropist-badge.svg';
import HitchhikerBadge from 'assets/images/badges/hitchhiker-badge.svg';
import MoneyBagsBadge from 'assets/images/badges/money-bags-badge.svg';
import SocialButterflyBadge from 'assets/images/badges/social-butterfly-badge.svg';
import TagAlongBadge from 'assets/images/badges/tag-along-badge.svg';
import InflatorBadge from 'assets/images/badges/inflator-badge.svg';
import InfluencerBadge from 'assets/images/badges/influencer.png';
import MostPopularBadge from 'assets/images/badges/most-popular-badge.svg';
import OneUpperBadge from 'assets/images/badges/one-upper-badge.svg';
import UnoriginalInflatorBadge from 'assets/images/badges/unoriginal-inflator-badge.svg';
import SidekickBadge from 'assets/images/badges/sidekick-badge.svg';
import NetworkerBadge from 'assets/images/badges/networker-badge.svg';

export const getBadgeIcon = (badgeName: string) => {
	let badgeIcon;
	switch (badgeName) {
		case 'Philanthropist':
			badgeIcon = PhilanthropistBadge;
			break;

		case 'Hitchhiker':
			badgeIcon = HitchhikerBadge;
			break;

		case 'Most Popular':
			badgeIcon = MostPopularBadge;
			break;

		case 'Sidekick':
			badgeIcon = SidekickBadge;
			break;

		case 'Tag-Along':
			badgeIcon = TagAlongBadge;
			break;

		case 'Inflator':
			badgeIcon = InflatorBadge;
			break;

		case 'Influencer':
			badgeIcon = InfluencerBadge;
			break;

		case 'Money Bags':
			badgeIcon = MoneyBagsBadge;
			break;

		case 'One Upper':
			badgeIcon = OneUpperBadge;
			break;

		case 'Unoriginal Inflator':
			badgeIcon = UnoriginalInflatorBadge;
			break;

		case 'Social Butterfly':
			badgeIcon = SocialButterflyBadge;
			break;

		case 'Networker':
			badgeIcon = NetworkerBadge;
			break;

		default:
			badgeIcon = PhilanthropistBadge;
			break;
	}

	return badgeIcon;
};
